import React, {useEffect, useState} from "react";
import { uniq } from "lodash";
import UploadNotification from "../modalPopups/uploadNotification.jsx";
import AddLabels, { AddLabelModalInstance } from "../modalPopups/addLabels.jsx";
import {API_URLS} from "../../constants/API_URLS.js";
import { hideLoader, showLoader } from "../../util/genericFunctions";
import Alert from "react-s-alert";
import ReactTooltip from "react-tooltip";
import {STATUS_CODES} from "../../constants/statusCodes";
//import { getAuthToken } from "../../util/authHelper";

let stompClient = null

const CommonComponent = (props) => {

  const [files, setFiles] = useState([])
  const [filePath, setFilePath] = useState('')

  useEffect(() => {
    props.setPathName(window.location.pathname)
    props.setLabels([])
  }, [])

  useEffect(() => {
    ReactTooltip.rebuild()
    setFiles(props.files)
  }, [props.files])

  useEffect(() => {
    ReactTooltip.rebuild()
    if (props.path === "/login" || props.path === "/signup") {
      props.clearFiles()
    }
  }, [props.path])

  useEffect(() => {
    if (props.user?.user?.email) {
      // initializeStompClient()
    }
  }, [props.user])

  useEffect(() => {
    setFilePath(props.filePath)
  }, [props.filePath])

  const initializeStompClient = () => {
    const Stomp = require('stompjs')
    let sockJS = require('sockjs-client')
    //sockJS = new sockJS(`${API_URLS.FEEDBACK_URL}?token=${getAuthToken()}`)
    sockJS = new sockJS(`${API_URLS.FEEDBACK_URL}`)
    stompClient = Stomp.over(sockJS)
    stompClient.debug = () => {}
    stompClient.connect({}, onConnected, onError)
  }

  const onConnected = () => {
    // Subscribing to the public topic
    if (stompClient.connected) {
      stompClient.subscribe(`/queue/${props.user.user.email}`, onMessageReceived)
    }
  }

  const onError = (error) => {
    //Alert.error(error)
    // Prevent continuously log errors on localhost because of sameSite cookies
    if (!window.location.hostname.includes("localhost")) {
      setTimeout(() => {
        // initializeStompClient()
      }, 2500)
    }
  }

  const onMessageReceived = (payload) => {
    const message = JSON.parse(payload.body)
    console.log('payload');
    console.log(message);
    if (message.uploadFrom.toLowerCase() === "vault") {
      let currentFile = files.find((x) => x.id === message.id)
      if (currentFile) {
        if (message.isFileProcessed === "true") {
          currentFile.isProcessed = true
          props.updateFiles(files)
        } else {
          currentFile.processFailed = true
          props.updateFiles(files)
        }
      }
    } else {
      props.updateUploadStatusThroughEmail(true)
    }
  }

  const addLabel = (labels, isNew) => {
    if (filePath || props.filePath) {
      showLoader()
      props.addLabel(
          labels,
          filePath || props.filePath,
          (res) => {
            handleAddLableResponse(res, isNew)
          },
          handleException
      )
    } else {
      let allLabels = props.allLabels || []
      props.setSelectedLabels(labels)
      props.setLabels(uniq([...allLabels, ...labels]))
      props.updateLabelStatus(true)
      AddLabelModalInstance() && AddLabelModalInstance().close()
    }
  }

  const handleAddLableResponse = (res, isNew) => {
    let removedLabels = props.selectedLabels.filter((name) => !res.includes(name))
    if (!isNew && !!removedLabels.length) {
      props.removeLabel(removedLabels, filePath || props.filePath, () => {
        Alert.success("Label updated successfully")
        let labels = props.allLabels || []
        props.setLabels(uniq([...labels, ...res]))
        props.updateLabelStatus(true)
        AddLabelModalInstance().close()
        hideLoader()
      })
    } else {
      Alert.success("Label added successfully")
      let labels = props.allLabels || []
      props.setLabels(uniq([...labels, ...res]))
      props.updateLabelStatus(true)
      AddLabelModalInstance().close()
      hideLoader()
    }
  }

  const handleException = (ex) => {
    if (ex.status === STATUS_CODES.BAD_REQUEST) {
      Alert.error(typeof ex.data === "string" ? ex.data : "Bad Request")
    } else if (ex.status === STATUS_CODES.INTERNAL_SERVER_ERROR) {
      Alert.error("Internal server error")
    }
    hideLoader()
  }

  return <div>
    {
      !!files.length && (
          props.location.pathname === "/" ||
          (
              props.location.pathname === "/document-side-view" &&
              props.hasDocumentTypeChange
          )
      ) && <UploadNotification
          onClose={props.clearFiles}
          files={files}
      />
    }

    <AddLabels
        addLabel={addLabel}
        allLabels={props.allLabels}
        selectedLabels={props.selectedLabels}
    />

    <ReactTooltip
        data-offset="top"
        place="bottom"
        type="dark"
        effect="float"
        globalEventOff="click"
        multiline
    />
  </div>
}

export default CommonComponent
